import { render, staticRenderFns } from "./DelegatesCreatePage.vue?vue&type=template&id=bc1bc1dc"
import script from "./DelegatesCreatePage.vue?vue&type=script&lang=ts"
export * from "./DelegatesCreatePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports